import { graphql, useStaticQuery } from 'gatsby'
import { useMemo } from 'react'
import { withoutPrefix } from '../utils/prefix'

export default function useBreadcrumbs({ pathname }) {
	const { allSitePage } = useStaticQuery(query)

	return useMemo(() => {
		const paths = {
			// virtual paths end with '#', but we want to use their `crumbTitle` nonetheless
			...Object.fromEntries(allSitePage.nodes.map(n => [n.path.replace(/#$/, ''), n.pageContext?.crumbTitle])),
			...bradcrumbOverrides,
		}

		const getTitle = href =>
			paths[href] ||
			paths[href.slice(0, -1) + '#'] ||
			paths[href.slice(0, -1) + '#' + '/']

		return withoutPrefix(pathname)
			.split('/')
			.map((_, index, array) => array.slice(0, index + 1).join('/') || '/')
			.filter(href => getTitle(href))
			.map(href => ({ href, title: getTitle(href) }))
	}, [allSitePage, pathname])
}

const query = graphql`
	query AllSitePage {
		allSitePage {
			nodes {
				path
				pageContext
			}
		}
	}
`

const bradcrumbOverrides = {
	'/': 'Home',
}
